import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Anlagen")
], -1)
const _hoisted_5 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mr-3 position-relative" }
const _hoisted_8 = {
  href: "#",
  class: "btn bg-transparent border-success text-success rounded-pill border-2 btn-icon"
}
const _hoisted_9 = {
  key: 0,
  class: "icon-exclamation position-absolute right-0 bg-danger text-white rounded-circle"
}
const _hoisted_10 = { class: "media-body" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (system, systemIndex) => {
          return (_openBlock(), _createElementBlock("li", {
            key: systemIndex,
            class: ""
          }, [
            _createElementVNode("a", {
              class: "media cursor-pointer align-items-center",
              onClick: ($event: any) => (_ctx.showSystem(system.anlage_id))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", _hoisted_8, [
                  _createElementVNode("i", {
                    class: _normalizeClass(system.icon)
                  }, null, 2)
                ]),
                (system.errors !== null)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(system.anlage_typ) + " | " + _toDisplayString(system.anlage_nummer) + " ", 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(system.anlage_bemerkung), 1),
                (system.errors !== null)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(system.errors, (err, errIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: errIndex,
                        class: "text-danger font-size-xs"
                      }, _toDisplayString(err.text), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_12
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}